<template>
  <div class="manager-dashboard px-4">
    <h2 class="my-2">{{ getShopTitle }} - Reports Overview</h2>
    <v-row>
      <v-col cols="12" md="8">
        <ChartNinetyDaySales />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <ChartThirtyDaySalesOverview />
      </v-col>
      <v-col cols="12" sm="6" md="4" order-md="4">
        <ChartThirtyDayTopProductsByRevenue />
      </v-col>
      <v-col cols="12" md="8" order-md="3">
        <ChartThirtyDayNewVsReturningCustomers />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ChartNinetyDaySales from '@/components/ChartNinetyDaySales'
import ChartThirtyDaySalesOverview from '@/components/ChartThirtyDaySalesOverview'
import ChartThirtyDayTopProductsByRevenue from '@/components/ChartThirtyDayTopProductsByRevenue'
import ChartThirtyDayNewVsReturningCustomers from '@/components/ChartThirtyDayNewVsReturningCustomers'
export default {
  name: 'MerchantDashboard',
  components: {
    ChartNinetyDaySales,
    ChartThirtyDaySalesOverview,
    ChartThirtyDayTopProductsByRevenue,
    ChartThirtyDayNewVsReturningCustomers,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('shop', ['getShopTitle']),
  },
}
</script>
